import i18next from 'i18next';
import api from '~/services/api';

const changeLanguage = lng => {
  i18next.changeLanguage(lng);
  api.defaults.headers['X-LOCALE'] = lng;
};

export const languageOptions = () => {
  const defaultOptions = [
    {
      label: 'ES',
      action: () => changeLanguage('es'),
    },
    {
      label: 'EN',
      action: () => changeLanguage('en'),
    },
  ];
  return defaultOptions.filter(opt => opt.label !== i18next.t('languageId'));
};
